import { j as e, T as _, V as C } from "./Spinner-dTAYYnIx.js";
import { t as v } from "./index-M5QJYDAG.js";
import { D as c } from "./domPurify-ugx5Lmst.js";
import { C as f } from "./Container-acMbkeg4.js";
import { S as h } from "./Section-cF107_Su.js";
import { C as D, R as H } from "./Row-qde4lVc-.js";
import { styled as s } from "styled-components";
import { T as i } from "./typography.styled-aDVGHct9.js";
import { e as r, f as p, p as I } from "./index-QRkynDgW.js";
import { o as R, T as n, d as L, m as M, B as k } from "./style-8UHgYe1v.js";
import { L as A } from "./LandingPageTag-Is1FMZqq.js";
import { S as w } from "./ShareModal-Bru1zaXh.js";
const B = s(i)`
  margin: ${r.spacer4} 0;
`, E = s.time`
  ${R(n.labelS)}
`, $ = s(D).attrs((t) => ({ $flexDirection: "column", ...t }))`
  ${p};
`, F = s.ul.attrs({
  $alignItems: "center",
  $justifyContent: "center",
  $flexWrap: "wrap"
})`
  ${p};
  margin: ${r.spacer4} 0 0 0;
  padding-left: 0;
  list-style: none;

  li {
    margin: ${r.spacer1};
  }
`, O = s.div.attrs({
  $alignItems: "baseline",
  $justifyContent: "center"
})`
  ${p};
  margin-top: ${r.spacer5};
  margin-bottom: ${r.spacer5};

  > :nth-child(2) {
    margin-left: ${r.spacer1};
    padding-left: ${r.spacer1};
    border-left: 1px solid;
    ${L("border-color", "dominantAlpha10")};
  }

  @media ${M(k.md)} {
    margin-bottom: ${r.spacer4};
  }
`, X = ({
  author: t,
  date: a,
  theme: l,
  title: g,
  $position: j = "top",
  secondaryTitle: y,
  secondaryTitleAlignment: u = "center",
  secondaryTitleFontVariant: S = "serif",
  tags: d,
  shareModalProps: x
}) => {
  const T = (o) => o && v(o);
  return /* @__PURE__ */ e.jsx(_, { theme: l, children: /* @__PURE__ */ e.jsx(h, { $position: j, "data-qa": "story-header-component", children: /* @__PURE__ */ e.jsx(f, { $fluid: !0, children: /* @__PURE__ */ e.jsxs(H, { $flexDirection: { xs: "row", md: "row-reverse" }, children: [
    /* @__PURE__ */ e.jsx($, { $col: { md: 2 }, $alignItems: "flex-end", children: x && /* @__PURE__ */ e.jsx(w, { ...x }) }),
    /* @__PURE__ */ e.jsxs($, { $col: { md: 8 }, $offset: { md: 2 }, children: [
      /* @__PURE__ */ e.jsx(
        i,
        {
          as: "h1",
          $textAlign: "center",
          $variant: n.headingXlSerif,
          dangerouslySetInnerHTML: { __html: c(g, "inlineRichtext") }
        }
      ),
      /* @__PURE__ */ e.jsx(
        B,
        {
          as: "p",
          $textAlign: u,
          $variant: S === "serif" ? n.headingSSerif : n.headingSSans,
          dangerouslySetInnerHTML: { __html: c(y, "inlineRichtext") }
        }
      ),
      d && d.length > 0 && /* @__PURE__ */ e.jsx(F, { children: d.map(({ href: o, text: m, analytics: b }) => /* @__PURE__ */ e.jsx("li", { children: /* @__PURE__ */ e.jsx(
        A,
        {
          href: typeof o == "string" && o || "",
          text: typeof m == "string" && m || "",
          onClick: () => T(b)
        }
      ) }, m)) }),
      (a || t) && /* @__PURE__ */ e.jsxs(O, { children: [
        t && /* @__PURE__ */ e.jsx(i, { $variant: n.bodyXS, children: t }),
        a && /* @__PURE__ */ e.jsx(E, { children: a })
      ] })
    ] })
  ] }) }) }) });
}, V = s(h).attrs({
  $py: { xs: "spacer5", md: "spacer6", lg: "spacer7" }
})`
  ${I};
`, W = ({ title: t, secondaryTitle: a, accessibilityTitle: l }) => /* @__PURE__ */ e.jsx(V, { children: /* @__PURE__ */ e.jsxs(f, { $fluid: !0, children: [
  /* @__PURE__ */ e.jsx(
    i,
    {
      as: "h1",
      $variant: n.headingXlSerif,
      dangerouslySetInnerHTML: { __html: c(t, "inlineRichtext") },
      $mb: "spacer3",
      $textEllipsis: 2,
      $textAlign: "center"
    }
  ),
  /* @__PURE__ */ e.jsx(
    i,
    {
      as: "p",
      $variant: n.body,
      dangerouslySetInnerHTML: { __html: c(a, "inlineRichtext") },
      $textEllipsis: 2,
      $textAlign: "center"
    }
  ),
  l && /* @__PURE__ */ e.jsx(C, { children: /* @__PURE__ */ e.jsx(i, { as: "h2", children: l }) })
] }) }), re = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FeatureHeader: X,
  TopicHeader: W
}, Symbol.toStringTag, { value: "Module" }));
export {
  X as F,
  W as T,
  re as i
};
